/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, Delegate_$type, fromEnum, runOn, markType, INotifyPropertyChanged_$type, PropertyChangedEventArgs, enumGetBox } from "igniteui-react-core";
import { List$1 } from "igniteui-react-core";
import { Ripple } from "./Ripple";
import { NativeUI } from "igniteui-react-core";
import { ControlDisplayDensity_$type } from "igniteui-react-core";
import { KeyFrameAnimationFactory } from "igniteui-react-core";
import { ElevationMode_$type } from "igniteui-react-core";
import { ElevationHelper } from "./ElevationHelper";
import { ButtonDisplayStyle_$type } from "./ButtonDisplayStyle";
import { isNaN_ } from "igniteui-react-core";
import { BaseControlTheme_$type } from "igniteui-react-core";
import { CornerRadius } from "igniteui-react-core";
import { AnimationKeyFrameEffectTiming } from "igniteui-react-core";
import { ThemeResolver } from "./ThemeResolver";
import { ButtonClickEventArgs } from "./ButtonClickEventArgs";
import { Thickness } from "igniteui-react-core";
import { BrushUtil } from "igniteui-react-core";
/**
 * @hidden
 */
var ButtonView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ButtonView, _super);
    function ButtonView() {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.h = null;
        _this.c = null;
        _this.g = new List$1(Delegate_$type, 0);
        _this.d = true;
        _this.k = null;
        _this.i = null;
        _this.b = null;
        _this.j = null;
        _this.m = null;
        _this.l = null;
        return _this;
    }
    ButtonView.prototype.ag = function () {
    };
    ButtonView.prototype.f = function () {
        return true;
    };
    Object.defineProperty(ButtonView.prototype, "n", {
        get: function () {
            return this.k;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonView.prototype, "o", {
        get: function () {
            return this.j;
        },
        enumerable: true,
        configurable: true
    });
    ButtonView.prototype.aa = function (a) {
        var e_1, _a;
        var _this = this;
        if (a == null) {
            try {
                for (var _b = tslib_1.__values(fromEnum(this.g)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_1_1) {
                e_1 = { error: e_1_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_1)
                        throw e_1.error;
                }
            }
            this.g.clear();
            return;
        }
        this.h = a;
        this.h.rootWrapper.setStyleProperty("display", "flex");
        this.h.rootWrapper.setStyleProperty("flex-direction", "row");
        this.h.rootWrapper.setStyleProperty("flex-wrap", "no-wrap");
        this.h.rootWrapper.setStyleProperty("align-items", "center");
        var c = this.h.createElement("button");
        this.k = c;
        this.k.setStyleProperty("position", "relative");
        this.k.setStyleProperty("display", "inline-flex");
        this.k.setStyleProperty("align-items", "center");
        this.k.setStyleProperty("justify-content", "center");
        this.an();
        this.k.setStyleProperty("border", "none");
        this.k.setStyleProperty("cursor", "pointer");
        this.k.setStyleProperty("user-select", "none");
        this.k.setStyleProperty("outline-style", "none");
        this.k.setStyleProperty("-webkit-tap-highlight-color", "transparent");
        this.k.setStyleProperty("overflow", "hidden");
        this.k.setStyleProperty("white-space", "no-wrap");
        this.k.setStyleProperty("color", "#000");
        this.k.setStyleProperty("background", this.a.my._fill);
        NativeUI.l(this.k, this.a.j2);
        this.k.setAttribute("id", this.a.h0);
        this.ak();
        this.g.add(c.listen("change", runOn(this, this.t)));
        this.g.add(c.listen("click", runOn(this, this.u)));
        this.g.add(c.listen("focus", runOn(this, this.v)));
        this.g.add(c.listen("blur", runOn(this, this.s)));
        this.g.add(this.h.rootWrapper.listen("mouseenter", runOn(this, this.q)));
        this.g.add(this.h.rootWrapper.listen("mouseleave", runOn(this, this.r)));
        this.h.append(c);
        var d = this.h.createElement("div");
        var e = this.h.getSubRenderer(d);
        d.setStyleProperty("position", "absolute");
        d.setStyleProperty("width", "100%");
        d.setStyleProperty("height", "100%");
        d.setStyleProperty("left", "0px");
        d.setStyleProperty("top", "0px");
        d.setStyleProperty("overflow", "hidden");
        var f = new Ripple();
        f.provideContainer(e);
        f.p = c;
        var g = this.h.getExternal(f, this.h.rootWrapper, this.h.getExternal(this.a, null, null));
        f.g = false;
        f.j = true;
        this.b = f;
        this.k.append(d);
        var h = this.h.createElement("div");
        h.addClass("ig-button-content");
        h.setStyleProperty("font-family", "'Segoe UI', Verdana");
        h.setStyleProperty("font-weight", "400");
        h.setStyleProperty("font-size", ".875rem");
        h.setStyleProperty("cursor", "pointer");
        this.j = h;
        this.g.add(h.listen("click", runOn(this, this.p)));
        this.k.append(h);
        this.l = h;
        this.h.getPortal(h, "ChildContent", function (i) {
            var comp_ = i.componentRef;
            _this.m = comp_;
            {
                _this.l.setStyleProperty("flex-direction", _this.a.g7);
                _this.l.setStyleProperty("align-items", _this.a.fp);
                var direction_ = _this.a.g7;
                var display_ = _this.a.f5;
                var alignItems_ = _this.a.fp;
                comp_.display = display_;
                comp_.flexDirection = direction_;
                comp_.alignItems = alignItems_;
            }
        }, true);
        this.a.jp();
    };
    ButtonView.prototype.ac = function () {
        this.b.h = this.a.ad;
    };
    ButtonView.prototype.an = function () {
        var a = "2.25rem";
        var b = "2.25rem";
        var c = "2.25rem";
        var d = "2.25rem";
        var e = "3.5rem";
        var f = "3.5rem";
        var g = "3.5rem";
        var h = "3.5rem";
        var i = "5.5rem";
        var j = "2.25rem";
        var k = "0px";
        var l = ".9375rem";
        var m = ".5625rem 1rem";
        switch (this.a.g) {
            case 2:
                m = ".375rem .75rem";
                j = "1.875rem";
                e = "3rem";
                f = "3rem";
                g = "3rem";
                h = "3rem";
                l = ".6875rem";
                break;
            case 3:
                m = ".1875rem 1rem";
                j = "1.5rem";
                f = "2.5rem";
                e = "2.5rem";
                h = "2.5rem";
                g = "2.5rem";
                l = ".4375rem";
                break;
        }
        if (this.a.r == 4) {
            this.k.setStyleProperty("min-width", a);
            this.k.setStyleProperty("min-height", b);
            this.k.setStyleProperty("padding", k);
            this.k.setStyleProperty("width", c);
            this.k.setStyleProperty("height", d);
        }
        else if (this.a.r == 3) {
            this.k.setStyleProperty("min-width", e);
            this.k.setStyleProperty("min-height", f);
            this.k.setStyleProperty("padding", l);
            this.k.setStyleProperty("width", g);
            this.k.setStyleProperty("height", h);
        }
        else {
            this.k.setStyleProperty("min-width", i);
            this.k.setStyleProperty("min-height", j);
            this.k.setStyleProperty("padding", m);
        }
        if (!isNaN_(this.a.at) && this.a.at > 0) {
            this.k.setStyleProperty("border-style", "solid");
        }
        else {
            this.k.setStyleProperty("border-style", "none");
        }
    };
    ButtonView.prototype.ai = function () {
        this.k.setAttribute("disabled", this.a.disabled ? "true" : "false");
        this.k.setProperty("disabled", this.a.disabled);
    };
    ButtonView.prototype.ad = function () {
        if (this.h != null) {
            this.h.rootWrapper.setStyleProperty("display", this.a.f5);
            var comp_ = this.m;
            if (this.m != null) {
                this.l.setStyleProperty("display", this.a.f5);
                var display_ = this.a.f5;
                comp_.display = display_;
            }
            var ext_ = this.h.getExternal(this.a, null, null);
            if (ext_ && ext_._onDisplayChanged) {
                ext_._onDisplayChanged();
            }
            ;
        }
    };
    ButtonView.prototype.y = function () {
        if (this.h != null) {
            this.h.rootWrapper.setStyleProperty("align-items", this.a.fp);
            this.k.setStyleProperty("align-items", this.a.fp);
            var comp_ = this.m;
            if (this.m != null) {
                this.l.setStyleProperty("align-items", this.a.fp);
                var alignItems_ = this.a.fp;
                comp_.alignItems = alignItems_;
            }
            var ext_ = this.h.getExternal(this.a, null, null);
            if (ext_ && ext_._onAlignItemsChanged) {
                ext_._onAlignItemsChanged();
            }
            ;
        }
    };
    ButtonView.prototype.ae = function () {
        if (this.h != null) {
            this.h.rootWrapper.setStyleProperty("flex-direction", this.a.g7);
            this.k.setStyleProperty("flex-direction", this.a.g7);
            var ext_ = this.h.getExternal(this.a, null, null);
            var comp_ = this.m;
            if (this.m != null) {
                this.l.setStyleProperty("flex-direction", this.a.g7);
                var direction_ = this.a.g7;
                comp_.flexDirection = direction_;
            }
            if (ext_ && ext_._onFlexDirectionChanged) {
                ext_._onFlexDirectionChanged();
            }
            ;
        }
    };
    ButtonView.prototype.af = function () {
        if (this.h != null) {
            this.h.rootWrapper.setStyleProperty("flex-grow", this.a.g9);
            this.k.setStyleProperty("flex-grow", this.a.g9);
            var ext_ = this.h.getExternal(this.a, null, null);
            if (ext_ && ext_._onFlexGrowChanged) {
                ext_._onFlexGrowChanged();
            }
            ;
        }
    };
    ButtonView.prototype.p = function (a) {
    };
    ButtonView.prototype.ak = function () {
        if (this.f()) {
            var a = this.a.h0;
            this.k.setAttribute("name", this.a.h6);
            this.k.setProperty("value", this.a.et);
            if (this.a.ag) {
                this.k.setAttribute("tabindex", this.a.ep.toString());
            }
            this.k.setProperty("disabled", this.a.disabled);
            {
            }
            this.k.setAttribute("aria-label", this.a.fr);
        }
    };
    ButtonView.prototype.ah = function () {
        if (this.f()) {
            var a = this.a.h0;
            this.k.setAttribute("id", a);
        }
    };
    ButtonView.prototype.q = function (a) {
        this.a.jm();
    };
    ButtonView.prototype.r = function (a) {
        this.a.jn();
    };
    ButtonView.prototype.s = function (a) {
        this.a.ji();
    };
    ButtonView.prototype.v = function (a) {
        this.a.jl();
    };
    ButtonView.prototype.u = function (a) {
        this.a.jj();
    };
    ButtonView.prototype.e = function () {
        return false;
    };
    ButtonView.prototype.t = function (a) {
    };
    ButtonView.prototype.x = function () {
        if (KeyFrameAnimationFactory.h == null) {
            KeyFrameAnimationFactory.h = this.h;
        }
    };
    ButtonView.prototype.z = function () {
        this.d = true;
        this.g.add(this.k.listen("change", runOn(this, this.t)));
        this.g.add(this.k.listen("click", runOn(this, this.u)));
        this.g.add(this.k.listen("focus", runOn(this, this.v)));
        this.g.add(this.k.listen("blur", runOn(this, this.s)));
        this.g.add(this.j.listen("click", runOn(this, this.p)));
        this.g.add(this.k.listen("mouseenter", runOn(this, this.q)));
        this.g.add(this.k.listen("mouseleave", runOn(this, this.r)));
    };
    ButtonView.prototype.ab = function () {
        var e_2, _a;
        this.d = false;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.g)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_2_1) {
            e_2 = { error: e_2_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_2)
                    throw e_2.error;
            }
        }
        this.g.clear();
    };
    ButtonView.prototype.aj = function () {
        var model_ = this.a;
        if (model_.externalObject && model_.externalObject.refreshDefaults) {
            model_.externalObject.refreshDefaults();
        }
        ;
    };
    ButtonView.prototype.al = function (a, b) {
        this.b.au = a;
        this.b.at = b;
    };
    ButtonView.prototype.am = function (a, b) {
        var c = ElevationHelper.e(a, this.a.na, this.a.m7, this.a.mx, b);
        this.k.setStyleProperty("box-shadow", c);
    };
    ButtonView.prototype.ao = function (a) {
        if (a != null) {
            this.j.setStyleProperty("font", a.fontString);
        }
    };
    ButtonView.prototype.w = function (a) {
        this.j.append(a);
    };
    ButtonView.$t = markType(ButtonView, 'ButtonView');
    return ButtonView;
}(Base));
export { ButtonView };
/**
 * @hidden
 */
var Button = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Button, _super);
    function Button() {
        var _this = _super.call(this) || this;
        _this._view = null;
        _this.r6 = ThemeResolver.e(Button.c, Button.ri, Button.oz);
        _this.ru = ThemeResolver.e(Button.c, Button.q6, Button.on);
        _this.nd = ThemeResolver.e(Button.c, Button.px, Button.ne);
        _this.m = ThemeResolver.a(Button.c, Button.n, Button.l);
        _this.rx = ThemeResolver.e(Button.c, Button.q9, Button.oq);
        _this.ry = ThemeResolver.e(Button.c, Button.ra, Button.or);
        _this.rz = ThemeResolver.e(Button.c, Button.rb, Button.os);
        _this.dx = ThemeResolver.c(Button.c, Button.dp, Button.cs);
        _this.d0 = ThemeResolver.c(Button.c, Button.ds, Button.cv);
        _this.dz = ThemeResolver.c(Button.c, Button.dr, Button.cu);
        _this.dy = ThemeResolver.c(Button.c, Button.dq, Button.ct);
        _this.rw = ThemeResolver.e(Button.c, Button.q8, Button.op);
        _this.r4 = ThemeResolver.e(Button.c, Button.rg, Button.ox);
        _this.kj = ThemeResolver.d(Button.c, Button.kh, Button.j9);
        _this.a9 = ThemeResolver.b(Button.c, Button.a7, Button.az);
        _this.rv = ThemeResolver.e(Button.c, Button.q7, Button.oo);
        _this.r5 = ThemeResolver.e(Button.c, Button.rh, Button.oy);
        _this.r3 = ThemeResolver.e(Button.c, Button.rf, Button.ow);
        _this.r2 = ThemeResolver.e(Button.c, Button.re, Button.ov);
        _this.r0 = ThemeResolver.e(Button.c, Button.rc, Button.ot);
        _this.r1 = ThemeResolver.e(Button.c, Button.rd, Button.ou);
        _this.pd = ThemeResolver.e(Button.c, Button.qb, Button.ns);
        _this.pe = ThemeResolver.e(Button.c, Button.qc, Button.nt);
        _this.pf = ThemeResolver.e(Button.c, Button.qd, Button.nu);
        _this.c0 = ThemeResolver.c(Button.c, Button.dc, Button.cg);
        _this.c3 = ThemeResolver.c(Button.c, Button.df, Button.cj);
        _this.c2 = ThemeResolver.c(Button.c, Button.de, Button.ci);
        _this.c1 = ThemeResolver.c(Button.c, Button.dd, Button.ch);
        _this.pc = ThemeResolver.e(Button.c, Button.qa, Button.nr);
        _this.pk = ThemeResolver.e(Button.c, Button.qi, Button.nz);
        _this.kb = ThemeResolver.d(Button.c, Button.ke, Button.j6);
        _this.a1 = ThemeResolver.b(Button.c, Button.a4, Button.aw);
        _this.pb = ThemeResolver.e(Button.c, Button.p9, Button.nq);
        _this.pl = ThemeResolver.e(Button.c, Button.qj, Button.n0);
        _this.pj = ThemeResolver.e(Button.c, Button.qh, Button.ny);
        _this.pi = ThemeResolver.e(Button.c, Button.qg, Button.nx);
        _this.pg = ThemeResolver.e(Button.c, Button.qe, Button.nv);
        _this.ph = ThemeResolver.e(Button.c, Button.qf, Button.nw);
        _this.rl = ThemeResolver.e(Button.c, Button.qx, Button.oe);
        _this.rm = ThemeResolver.e(Button.c, Button.qy, Button.of);
        _this.rn = ThemeResolver.e(Button.c, Button.qz, Button.og);
        _this.dt = ThemeResolver.c(Button.c, Button.dk, Button.co);
        _this.dw = ThemeResolver.c(Button.c, Button.dn, Button.cr);
        _this.dv = ThemeResolver.c(Button.c, Button.dm, Button.cq);
        _this.du = ThemeResolver.c(Button.c, Button.dl, Button.cp);
        _this.rk = ThemeResolver.e(Button.c, Button.qw, Button.od);
        _this.rs = ThemeResolver.e(Button.c, Button.q4, Button.ol);
        _this.ki = ThemeResolver.d(Button.c, Button.kg, Button.j8);
        _this.a8 = ThemeResolver.b(Button.c, Button.a6, Button.ay);
        _this.rj = ThemeResolver.e(Button.c, Button.qv, Button.oc);
        _this.rt = ThemeResolver.e(Button.c, Button.q5, Button.om);
        _this.rr = ThemeResolver.e(Button.c, Button.q3, Button.ok);
        _this.rq = ThemeResolver.e(Button.c, Button.q2, Button.oj);
        _this.ro = ThemeResolver.e(Button.c, Button.q0, Button.oh);
        _this.rp = ThemeResolver.e(Button.c, Button.q1, Button.oi);
        _this.po = ThemeResolver.e(Button.c, Button.qm, Button.n3);
        _this.pp = ThemeResolver.e(Button.c, Button.qn, Button.n4);
        _this.pq = ThemeResolver.e(Button.c, Button.qo, Button.n5);
        _this.c4 = ThemeResolver.c(Button.c, Button.dg, Button.ck);
        _this.c7 = ThemeResolver.c(Button.c, Button.dj, Button.cn);
        _this.c6 = ThemeResolver.c(Button.c, Button.di, Button.cm);
        _this.c5 = ThemeResolver.c(Button.c, Button.dh, Button.cl);
        _this.pn = ThemeResolver.e(Button.c, Button.ql, Button.n2);
        _this.pv = ThemeResolver.e(Button.c, Button.qt, Button.oa);
        _this.kc = ThemeResolver.d(Button.c, Button.kf, Button.j7);
        _this.a2 = ThemeResolver.b(Button.c, Button.a5, Button.ax);
        _this.pm = ThemeResolver.e(Button.c, Button.qk, Button.n1);
        _this.pw = ThemeResolver.e(Button.c, Button.qu, Button.ob);
        _this.pu = ThemeResolver.e(Button.c, Button.qs, Button.n9);
        _this.pt = ThemeResolver.e(Button.c, Button.qr, Button.n8);
        _this.pr = ThemeResolver.e(Button.c, Button.qp, Button.n6);
        _this.ps = ThemeResolver.e(Button.c, Button.qq, Button.n7);
        _this.o2 = ThemeResolver.e(Button.c, Button.p0, Button.nh);
        _this.o3 = ThemeResolver.e(Button.c, Button.p1, Button.ni);
        _this.o4 = ThemeResolver.e(Button.c, Button.p2, Button.nj);
        _this.cw = ThemeResolver.c(Button.c, Button.c8, Button.cc);
        _this.cz = ThemeResolver.c(Button.c, Button.db, Button.cf);
        _this.cy = ThemeResolver.c(Button.c, Button.da, Button.ce);
        _this.cx = ThemeResolver.c(Button.c, Button.c9, Button.cd);
        _this.o1 = ThemeResolver.e(Button.c, Button.pz, Button.ng);
        _this.o9 = ThemeResolver.e(Button.c, Button.p7, Button.no);
        _this.ka = ThemeResolver.d(Button.c, Button.kd, Button.j5);
        _this.a0 = ThemeResolver.b(Button.c, Button.a3, Button.av);
        _this.o0 = ThemeResolver.e(Button.c, Button.py, Button.nf);
        _this.pa = ThemeResolver.e(Button.c, Button.p8, Button.np);
        _this.o8 = ThemeResolver.e(Button.c, Button.p6, Button.nn);
        _this.o7 = ThemeResolver.e(Button.c, Button.p5, Button.nm);
        _this.o5 = ThemeResolver.e(Button.c, Button.p3, Button.nk);
        _this.o6 = ThemeResolver.e(Button.c, Button.p4, Button.nl);
        _this.q = 0;
        _this.f = 0;
        _this.b = 0;
        _this.e = 1;
        _this.kr = ThemeResolver.e(Button.c, Button.q8, Button.op);
        _this.k2 = ThemeResolver.e(Button.c, Button.ri, Button.oz);
        _this.kz = ThemeResolver.e(Button.c, Button.q6, Button.on);
        _this.kp = ThemeResolver.e(Button.c, Button.px, Button.ne);
        _this.bi = ThemeResolver.c(Button.c, Button.ds, Button.cv);
        _this.bg = ThemeResolver.c(Button.c, Button.dq, Button.ct);
        _this.bh = ThemeResolver.c(Button.c, Button.dr, Button.cu);
        _this.k0 = ThemeResolver.e(Button.c, Button.rg, Button.ox);
        _this.jv = ThemeResolver.d(Button.c, Button.kh, Button.j9);
        _this.kq = ThemeResolver.e(Button.c, Button.q7, Button.oo);
        _this.ks = ThemeResolver.e(Button.c, Button.q9, Button.oq);
        _this.kt = ThemeResolver.e(Button.c, Button.ra, Button.or);
        _this.ku = ThemeResolver.e(Button.c, Button.rb, Button.os);
        _this.bf = ThemeResolver.c(Button.c, Button.dp, Button.cs);
        _this.i = ThemeResolver.a(Button.c, Button.n, Button.l);
        _this.k1 = ThemeResolver.e(Button.c, Button.rh, Button.oy);
        _this.ky = ThemeResolver.e(Button.c, Button.rf, Button.ow);
        _this.kv = ThemeResolver.e(Button.c, Button.rc, Button.ot);
        _this.kw = ThemeResolver.e(Button.c, Button.rd, Button.ou);
        _this.kx = ThemeResolver.e(Button.c, Button.re, Button.ov);
        _this.am = ThemeResolver.b(Button.c, Button.a7, Button.az);
        _this.mk = null;
        _this.mm = null;
        _this.mn = null;
        _this.mo = null;
        _this.b2 = -1;
        _this.mr = null;
        _this.ml = null;
        _this.b5 = -1;
        _this.b4 = -1;
        _this.b3 = -1;
        _this.as = NaN;
        _this.j1 = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.mt = null;
        _this.li = null;
        _this.lk = null;
        _this.ll = null;
        _this.lm = null;
        _this.bo = -1;
        _this.lp = null;
        _this.lj = null;
        _this.br = -1;
        _this.bq = -1;
        _this.bp = -1;
        _this.lr = null;
        _this.ls = null;
        _this.lq = null;
        _this.ln = null;
        _this.lo = null;
        _this.ap = NaN;
        _this.jy = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.k3 = null;
        _this.k5 = null;
        _this.k6 = null;
        _this.k7 = null;
        _this.bj = -1;
        _this.j = 0;
        _this.lv = null;
        _this.k4 = null;
        _this.b6 = -1;
        _this.bt = -1;
        _this.bs = -1;
        _this.t = null;
        _this.mw = null;
        _this.lx = null;
        _this.mv = null;
        _this.mu = null;
        _this.ms = null;
        _this.mp = null;
        _this.mq = null;
        _this.lt = null;
        _this.lu = null;
        _this.an = NaN;
        _this.jw = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.l9 = null;
        _this.mb = null;
        _this.mc = null;
        _this.md = null;
        _this.by = -1;
        _this.mg = null;
        _this.ma = null;
        _this.b1 = -1;
        _this.b0 = -1;
        _this.bz = -1;
        _this.ar = NaN;
        _this.j0 = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.mi = null;
        _this.mj = null;
        _this.mh = null;
        _this.me = null;
        _this.mf = null;
        _this.k8 = null;
        _this.la = null;
        _this.lb = null;
        _this.lc = null;
        _this.bk = -1;
        _this.lw = null;
        _this.k9 = null;
        _this.bn = -1;
        _this.bm = -1;
        _this.bl = -1;
        _this.ao = NaN;
        _this.jx = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.lg = null;
        _this.lh = null;
        _this.lf = null;
        _this.ld = null;
        _this.le = null;
        _this.ly = null;
        _this.l0 = null;
        _this.l1 = null;
        _this.l2 = null;
        _this.bu = -1;
        _this.l5 = null;
        _this.lz = null;
        _this.bx = -1;
        _this.bw = -1;
        _this.bv = -1;
        _this.aq = NaN;
        _this.jz = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.l7 = null;
        _this.l8 = null;
        _this.l6 = null;
        _this.l3 = null;
        _this.l4 = null;
        _this.e0 = "ig-native-button-" + Button.er++;
        _this.ez = "ig-button-" + Button.eq++;
        _this.ew = "inline-block";
        _this.ex = "inline-block";
        _this.ey = null;
        _this.eu = "center";
        _this.es = null;
        _this.e1 = null;
        _this.b7 = 0;
        _this.y = false;
        _this.aa = false;
        _this.ab = true;
        _this.ev = null;
        _this.w = false;
        _this.v = false;
        _this.ac = false;
        _this.z = false;
        _this.x = false;
        _this.propertyChanged = null;
        _this.clicked = null;
        var a = new ButtonView();
        a.a = _this;
        _this.view = a;
        _this.view.ag();
        return _this;
    }
    Object.defineProperty(Button.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: true,
        configurable: true
    });
    Button.prototype.destroy = function () {
        this.provideContainer(null);
    };
    Button.prototype.jo = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.jq(a, b, c);
    };
    Button.prototype.jq = function (a, b, c) {
        switch (a) {
            case "CornerRadius":
            case "BorderColor":
            case "RestingElevation":
            case "HoverElevation":
            case "FocusElevation":
            case "RippleColor":
            case "BorderWidth":
            case "BackgroundColor":
            case "DisabledBackgroundColor":
            case "DisabledBorderColor":
            case "DisabledTextColor":
            case "DisabledElevation":
            case "HoverBackgroundColor":
            case "TextStyle":
            case "FocusTextColor":
            case "TextColor":
            case "HoverTextColor":
            case "FocusBackgroundColor":
            case "RaisedBorderColor":
            case "RaisedRestingElevation":
            case "RaisedFocusElevation":
            case "RaisedHoverElevation":
            case "RaisedRippleColor":
            case "RaisedBorderWidth":
            case "RaisedBackgroundColor":
            case "RaisedDisabledBackgroundColor":
            case "RaisedDisabledBorderColor":
            case "RaisedDisabledTextColor":
            case "RaisedDisabledElevation":
            case "RaisedHoverBackgroundColor":
            case "RaisedCornerRadius":
            case "RaisedFocusBackgroundColor":
            case "RaisedFocusTextColor":
            case "RaisedTextColor":
            case "RaisedHoverTextColor":
            case "FlatBorderColor":
            case "FlatRestingElevation":
            case "FlatFocusElevation":
            case "FlatHoverElevation":
            case "FlatRippleColor":
            case "FlatBorderWidth":
            case "FlatBackgroundColor":
            case "FlatDisabledBackgroundColor":
            case "FlatDisabledBorderColor":
            case "FlatDisabledTextColor":
            case "FlatDisabledElevation":
            case "FlatHoverBackgroundColor":
            case "FlatCornerRadius":
            case "FlatFocusBackgroundColor":
            case "FlatFocusTextColor":
            case "FlatTextColor":
            case "FlatHoverTextColor":
            case "OutlinedRippleColor":
            case "OutlinedRestingElevation":
            case "OutlinedFocusElevation":
            case "OutlinedHoverElevation":
            case "OutlinedBorderColor":
            case "OutlinedBorderWidth":
            case "OutlinedBackgroundColor":
            case "OutlinedDisabledBackgroundColor":
            case "OutlinedDisabledBorderColor":
            case "OutlinedDisabledTextColor":
            case "OutlinedDisabledElevation":
            case "OutlinedHoverBackgroundColor":
            case "OutlinedCornerRadius":
            case "OutlinedFocusBackgroundColor":
            case "OutlinedFocusTextColor":
            case "OutlinedTextColor":
            case "OutlinedHoverTextColor":
            case "FabBorderColor":
            case "FabRippleColor":
            case "FabRestingElevation":
            case "FabFocusElevation":
            case "FabHoverElevation":
            case "FabBorderWidth":
            case "FabBackgroundColor":
            case "FabDisabledBackgroundColor":
            case "FabDisabledBorderColor":
            case "FabDisabledTextColor":
            case "FabDisabledElevation":
            case "FabHoverBackgroundColor":
            case "FabCornerRadius":
            case "FabFocusBackgroundColor":
            case "FabFocusTextColor":
            case "FabTextColor":
            case "FabHoverTextColor":
            case "IconRestingElevation":
            case "IconFocusElevation":
            case "IconHoverElevation":
            case "IconBorderColor":
            case "IconRippleColor":
            case "IconBorderWidth":
            case "IconBackgroundColor":
            case "IconDisabledBackgroundColor":
            case "IconDisabledBorderColor":
            case "IconDisabledTextColor":
            case "IconDisabledElevation":
            case "IconHoverBackgroundColor":
            case "IconCornerRadius":
            case "IconFocusBackgroundColor":
            case "IconFocusTextColor":
            case "IconTextColor":
            case "IconHoverTextColor":
            case "ElevationMode":
                this.jt();
                break;
            case "BaseTheme":
                this.ju(this.d == 0 ? 2 : this.d);
                this.jt();
                break;
            case "IsDisabled":
                this.ad = this.disabled || this.ae;
                this.jt();
                this.view.ai();
                break;
            case "DisableRipple":
                this.ad = this.disabled || this.ae;
                this.jt();
                break;
            case "ActualDisableRipple":
                this.view.ac();
                break;
            case "ActualBackgroundColor":
            case "ActualDisabledBackgroundColor":
            case "ActualDisabledBorderColor":
            case "ActualDisabledTextColor":
            case "ActualDisabledElevation":
            case "ActualHoverBackgroundColor":
            case "ActualBorderColor":
            case "ActualFocusTextColor":
            case "ActualHoverTextColor":
            case "ActualElevationMode":
                this.js();
                break;
            case "Density":
                this.g = this.h == 0 ? 1 : this.h;
                break;
            case "ActualDensity":
            case "ActualBorderWidth":
            case "ActualCornerRadius":
                this.view.an();
                this.js();
                break;
            case "DisplayType":
                this.view.an();
                this.jt();
                this.js();
                break;
            case "InputId":
                this.view.ah();
                break;
            case "Display":
                this.view.ad();
                break;
            case "FlexDirection":
                this.view.ae();
                break;
            case "FlexGrow":
                this.view.af();
                break;
            case "AlignItems":
                this.view.y();
                break;
        }
    };
    Button.prototype.j3 = function (a, b) {
        return new CornerRadius(1, !isNaN_(a.c) ? a.c : b.c, !isNaN_(a.d) ? a.d : b.d, !isNaN_(a.b) ? a.b : b.b, !isNaN_(a.a) ? a.a : b.a);
    };
    Button.prototype.jt = function () {
        this.k = this.o != 0 ? this.o : this.m;
        this.na = this.r6;
        this.m7 = this.ru;
        this.mx = this.nd;
        switch (this.r) {
            case 0:
                this.m0 = this.r7 != null ? this.r7 : this.to != null ? this.to : this.rx;
                this.m1 = this.r8 != null ? this.r8 : this.tp != null ? this.tp : this.ry;
                this.m2 = this.r9 != null ? this.r9 : this.tq != null ? this.tq : this.rz;
                this.b8 = this.d1 >= 0 ? this.d1 : this.ek >= 0 ? this.ek : this.dx;
                this.cb = this.eo >= 0 ? this.eo : this.en >= 0 ? this.en : this.d0;
                this.ca = this.eb >= 0 ? this.eb : this.em >= 0 ? this.em : this.dz;
                this.b9 = this.ea >= 0 ? this.ea : this.el >= 0 ? this.el : this.dy;
                this.mz = this.nc != null ? this.nc : this.tn != null ? this.tn : this.rw;
                this.my = this.nb != null ? this.nb : this.tm != null ? this.tm : this.rv;
                this.m5 = this.sy != null ? this.sy : this.tt != null ? this.tt : this.r2;
                this.j2 = this.j3(this.j4, this.j3(this.ko, this.kj));
                this.at = !isNaN_(this.au) ? this.au : !isNaN_(this.be) ? this.be : this.a9;
                this.m8 = this.tx != null ? this.tx : this.tv != null ? this.tv : this.r4;
                this.m3 = this.sw != null ? this.sw : this.tr != null ? this.tr : this.r0;
                this.m4 = this.sx != null ? this.sx : this.ts != null ? this.ts : this.r1;
                this.m9 = this.ty != null ? this.ty : this.tw != null ? this.tw : this.r5;
                this.m6 = this.sz != null ? this.sz : this.tu != null ? this.tu : this.r3;
                break;
            case 2:
                this.m0 = this.r7 != null ? this.r7 : this.td != null ? this.td : this.rl;
                this.m1 = this.r8 != null ? this.r8 : this.te != null ? this.te : this.rm;
                this.m2 = this.r9 != null ? this.r9 : this.tf != null ? this.tf : this.rn;
                this.b8 = this.d1 >= 0 ? this.d1 : this.eg >= 0 ? this.eg : this.dt;
                this.cb = this.eo >= 0 ? this.eo : this.ej >= 0 ? this.ej : this.dw;
                this.ca = this.eb >= 0 ? this.eb : this.ei >= 0 ? this.ei : this.dv;
                this.b9 = this.ea >= 0 ? this.ea : this.eh >= 0 ? this.eh : this.du;
                this.mz = this.nc != null ? this.nc : this.tc != null ? this.tc : this.rk;
                this.my = this.sy != null ? this.sy : this.nb != null ? this.nb : this.tb != null ? this.tb : this.rj;
                this.m5 = this.ti != null ? this.ti : this.rq;
                this.j2 = this.j3(this.j4, this.j3(this.kn, this.ki));
                this.at = !isNaN_(this.au) ? this.au : !isNaN_(this.bd) ? this.bd : this.a8;
                this.m8 = this.tx != null ? this.tx : this.tk != null ? this.tk : this.rs;
                this.m3 = this.sw != null ? this.sw : this.tg != null ? this.tg : this.ro;
                this.m4 = this.sx != null ? this.sx : this.th != null ? this.th : this.rp;
                this.m9 = this.ty != null ? this.ty : this.tl != null ? this.tl : this.rt;
                this.m6 = this.sz != null ? this.sz : this.tj != null ? this.tj : this.rr;
                break;
            case 1:
                this.m0 = this.r7 != null ? this.r7 : this.sn != null ? this.sn : this.pd;
                this.m1 = this.r8 != null ? this.r8 : this.so != null ? this.so : this.pe;
                this.m2 = this.r9 != null ? this.r9 : this.sp != null ? this.sp : this.pf;
                this.b8 = this.d1 >= 0 ? this.d1 : this.d6 >= 0 ? this.d6 : this.c0;
                this.cb = this.eo >= 0 ? this.eo : this.d9 >= 0 ? this.d9 : this.c3;
                this.ca = this.eb >= 0 ? this.eb : this.d8 >= 0 ? this.d8 : this.c2;
                this.b9 = this.ea >= 0 ? this.ea : this.d7 >= 0 ? this.d7 : this.c1;
                this.mz = this.nc != null ? this.nc : this.sm != null ? this.sm : this.pc;
                this.my = this.nb != null ? this.nb : this.sl != null ? this.sl : this.pb;
                this.m5 = this.sy != null ? this.sy : this.ss != null ? this.ss : this.pi;
                this.j2 = this.j3(this.j4, this.j3(this.kl, this.kb));
                this.at = !isNaN_(this.au) ? this.au : !isNaN_(this.bb) ? this.bb : this.a1;
                this.m8 = this.tx != null ? this.tx : this.su != null ? this.su : this.pk;
                this.m3 = this.sw != null ? this.sw : this.sq != null ? this.sq : this.pg;
                this.m4 = this.sx != null ? this.sx : this.sr != null ? this.sr : this.ph;
                this.m9 = this.ty != null ? this.ty : this.sv != null ? this.sv : this.pl;
                this.m6 = this.sz != null ? this.sz : this.st != null ? this.st : this.pj;
                break;
            case 4:
                this.m0 = this.r7 != null ? this.r7 : this.s2 != null ? this.s2 : this.po;
                this.m1 = this.r8 != null ? this.r8 : this.s3 != null ? this.s3 : this.pp;
                this.m2 = this.r9 != null ? this.r9 : this.s4 != null ? this.s4 : this.pq;
                this.b8 = this.d1 >= 0 ? this.d1 : this.ec >= 0 ? this.ec : this.c4;
                this.cb = this.eo >= 0 ? this.eo : this.ef >= 0 ? this.ef : this.c7;
                this.ca = this.eb >= 0 ? this.eb : this.ee >= 0 ? this.ee : this.c6;
                this.b9 = this.ea >= 0 ? this.ea : this.ed >= 0 ? this.ed : this.c5;
                this.mz = this.nc != null ? this.nc : this.s1 != null ? this.s1 : this.pn;
                this.my = this.nb != null ? this.nb : this.s0 != null ? this.s0 : this.pm;
                this.m5 = this.sy != null ? this.sy : this.s7 != null ? this.s7 : this.pt;
                this.j2 = this.j3(this.j4, this.j3(this.km, this.kc));
                this.at = !isNaN_(this.au) ? this.au : !isNaN_(this.bc) ? this.bc : this.a2;
                this.m8 = this.tx != null ? this.tx : this.s9 != null ? this.s9 : this.pv;
                this.m3 = this.sw != null ? this.sw : this.s5 != null ? this.s5 : this.pr;
                this.m4 = this.sx != null ? this.sx : this.s6 != null ? this.s6 : this.ps;
                this.m9 = this.ty != null ? this.ty : this.ta != null ? this.ta : this.pw;
                this.m6 = this.sz != null ? this.sz : this.s8 != null ? this.s8 : this.pu;
                break;
            case 3:
                this.m0 = this.r7 != null ? this.r7 : this.sc != null ? this.sc : this.o2;
                this.m1 = this.r8 != null ? this.r8 : this.sd != null ? this.sd : this.o3;
                this.m2 = this.r9 != null ? this.r9 : this.se != null ? this.se : this.o4;
                this.b8 = this.d1 >= 0 ? this.d1 : this.d2 >= 0 ? this.d2 : this.cw;
                this.cb = this.eo >= 0 ? this.eo : this.d5 >= 0 ? this.d5 : this.cz;
                this.ca = this.eb >= 0 ? this.eb : this.d4 >= 0 ? this.d4 : this.cy;
                this.b9 = this.ea >= 0 ? this.ea : this.d3 >= 0 ? this.d3 : this.cx;
                this.mz = this.nc != null ? this.nc : this.sb != null ? this.sb : this.o1;
                this.my = this.nb != null ? this.nb : this.sa != null ? this.sa : this.o0;
                this.m5 = this.sy != null ? this.sy : this.sh != null ? this.sh : this.o7;
                this.j2 = this.j3(this.j4, this.j3(this.kk, this.ka));
                this.at = !isNaN_(this.au) ? this.au : !isNaN_(this.ba) ? this.ba : this.a0;
                this.m8 = this.tx != null ? this.tx : this.sj != null ? this.sj : this.r4;
                this.m3 = this.sw != null ? this.sw : this.sf != null ? this.sf : this.o5;
                this.m4 = this.sx != null ? this.sx : this.sg != null ? this.sg : this.o6;
                this.m9 = this.ty != null ? this.ty : this.sk != null ? this.sk : this.pa;
                this.m6 = this.sz != null ? this.sz : this.si != null ? this.si : this.o8;
                break;
        }
    };
    Button.prototype.jj = function () {
        if (this.disabled) {
            return;
        }
        if (this.clicked != null) {
            this.clicked(this, new ButtonClickEventArgs());
        }
    };
    Button.prototype.ji = function () {
        this.focused = false;
        this.js();
    };
    Button.prototype.jl = function () {
        this.focused = true;
        this.js();
    };
    Button.prototype.jn = function () {
        this.ak = false;
        this.js();
    };
    Button.prototype.jm = function () {
        this.ak = true;
        this.js();
    };
    Button.prototype.js = function () {
        var a = this.view.n;
        NativeUI.l(a, this.j2);
        NativeUI.k(a, this.mz);
        if (!isNaN_(this.at)) {
            NativeUI.m(a, new Thickness(0, this.at));
        }
        if (this.disabled) {
            this.view.am(this.b8, this.k);
        }
        else if (this.focused && this.aj) {
            this.view.am(this.b9, this.k);
        }
        else {
            if (this.ak) {
                this.view.am(this.ca, this.k);
            }
            else {
                this.view.am(this.cb, this.k);
            }
        }
        if (this.disabled) {
            NativeUI.j(a, this.m0);
        }
        else if (this.focused && this.aj) {
            NativeUI.j(a, this.m3);
        }
        else {
            if (this.ak) {
                NativeUI.j(a, this.m5);
            }
            else {
                NativeUI.j(a, this.my);
            }
        }
        this.view.al(this.m8, BrushUtil.g(0, 0, 0, 0));
        if (this.u != null) {
            this.view.ao(this.u);
        }
        if (this.disabled) {
            NativeUI.n(this.view.o, this.m2);
            NativeUI.o(this.view.o, this.m2);
        }
        else if (this.focused && this.aj) {
            NativeUI.n(this.view.o, this.m4);
            NativeUI.o(this.view.o, this.m4);
        }
        else {
            NativeUI.n(this.view.o, this.m9);
            NativeUI.o(this.view.o, this.m9);
        }
    };
    Button.prototype.ju = function (a) {
        this.r6 = ThemeResolver.e(a, Button.ri, Button.oz);
        this.ru = ThemeResolver.e(a, Button.q6, Button.on);
        this.nd = ThemeResolver.e(a, Button.px, Button.ne);
        this.m = ThemeResolver.a(a, Button.n, Button.l);
        this.rx = ThemeResolver.e(a, Button.q9, Button.oq);
        this.ry = ThemeResolver.e(a, Button.ra, Button.or);
        this.rz = ThemeResolver.e(a, Button.rb, Button.os);
        this.dx = ThemeResolver.c(a, Button.dp, Button.cs);
        this.d0 = ThemeResolver.c(a, Button.ds, Button.cv);
        this.dz = ThemeResolver.c(a, Button.dr, Button.cu);
        this.dy = ThemeResolver.c(a, Button.dq, Button.ct);
        this.rw = ThemeResolver.e(a, Button.q8, Button.op);
        this.r4 = ThemeResolver.e(a, Button.rg, Button.ox);
        this.kj = ThemeResolver.d(a, Button.kh, Button.j9);
        this.a9 = ThemeResolver.b(a, Button.a7, Button.az);
        this.rv = ThemeResolver.e(a, Button.q7, Button.oo);
        this.r5 = ThemeResolver.e(a, Button.rh, Button.oy);
        this.r3 = ThemeResolver.e(a, Button.rf, Button.ow);
        this.r2 = ThemeResolver.e(a, Button.re, Button.ov);
        this.r0 = ThemeResolver.e(a, Button.rc, Button.ot);
        this.r1 = ThemeResolver.e(a, Button.rd, Button.ou);
        this.pd = ThemeResolver.e(a, Button.qb, Button.ns);
        this.pe = ThemeResolver.e(a, Button.qc, Button.nt);
        this.pf = ThemeResolver.e(a, Button.qd, Button.nu);
        this.c0 = ThemeResolver.c(a, Button.dc, Button.cg);
        this.c3 = ThemeResolver.c(a, Button.df, Button.cj);
        this.c2 = ThemeResolver.c(a, Button.de, Button.ci);
        this.c1 = ThemeResolver.c(a, Button.dd, Button.ch);
        this.pc = ThemeResolver.e(a, Button.qa, Button.nr);
        this.pk = ThemeResolver.e(a, Button.qi, Button.nz);
        this.kb = ThemeResolver.d(a, Button.ke, Button.j6);
        this.a1 = ThemeResolver.b(a, Button.a4, Button.aw);
        this.pb = ThemeResolver.e(a, Button.p9, Button.nq);
        this.pl = ThemeResolver.e(a, Button.qj, Button.n0);
        this.pj = ThemeResolver.e(a, Button.qh, Button.ny);
        this.pi = ThemeResolver.e(a, Button.qg, Button.nx);
        this.pg = ThemeResolver.e(a, Button.qe, Button.nv);
        this.ph = ThemeResolver.e(a, Button.qf, Button.nw);
        this.rl = ThemeResolver.e(a, Button.qx, Button.oe);
        this.rm = ThemeResolver.e(a, Button.qy, Button.of);
        this.rn = ThemeResolver.e(a, Button.qz, Button.og);
        this.dt = ThemeResolver.c(a, Button.dk, Button.co);
        this.dw = ThemeResolver.c(a, Button.dn, Button.cr);
        this.dv = ThemeResolver.c(a, Button.dm, Button.cq);
        this.du = ThemeResolver.c(a, Button.dl, Button.cp);
        this.rk = ThemeResolver.e(a, Button.qw, Button.od);
        this.rs = ThemeResolver.e(a, Button.q4, Button.ol);
        this.ki = ThemeResolver.d(a, Button.kg, Button.j8);
        this.a8 = ThemeResolver.b(a, Button.a6, Button.ay);
        this.rj = ThemeResolver.e(a, Button.qv, Button.oc);
        this.rt = ThemeResolver.e(a, Button.q5, Button.om);
        this.rr = ThemeResolver.e(a, Button.q3, Button.ok);
        this.rq = ThemeResolver.e(a, Button.q2, Button.oj);
        this.ro = ThemeResolver.e(a, Button.q0, Button.oh);
        this.rp = ThemeResolver.e(a, Button.q1, Button.oi);
        this.po = ThemeResolver.e(a, Button.qm, Button.n3);
        this.pp = ThemeResolver.e(a, Button.qn, Button.n4);
        this.pq = ThemeResolver.e(a, Button.qo, Button.n5);
        this.c4 = ThemeResolver.c(a, Button.dg, Button.ck);
        this.c7 = ThemeResolver.c(a, Button.dj, Button.cn);
        this.c6 = ThemeResolver.c(a, Button.di, Button.cm);
        this.c5 = ThemeResolver.c(a, Button.dh, Button.cl);
        this.pn = ThemeResolver.e(a, Button.ql, Button.n2);
        this.pv = ThemeResolver.e(a, Button.qt, Button.oa);
        this.kc = ThemeResolver.d(a, Button.kf, Button.j7);
        this.a2 = ThemeResolver.b(a, Button.a5, Button.ax);
        this.pm = ThemeResolver.e(a, Button.qk, Button.n1);
        this.pw = ThemeResolver.e(a, Button.qu, Button.ob);
        this.pu = ThemeResolver.e(a, Button.qs, Button.n9);
        this.pt = ThemeResolver.e(a, Button.qr, Button.n8);
        this.pr = ThemeResolver.e(a, Button.qp, Button.n6);
        this.ps = ThemeResolver.e(a, Button.qq, Button.n7);
        this.o2 = ThemeResolver.e(a, Button.p0, Button.nh);
        this.o3 = ThemeResolver.e(a, Button.p1, Button.ni);
        this.o4 = ThemeResolver.e(a, Button.p2, Button.nj);
        this.cw = ThemeResolver.c(a, Button.c8, Button.cc);
        this.cz = ThemeResolver.c(a, Button.db, Button.cf);
        this.cy = ThemeResolver.c(a, Button.da, Button.ce);
        this.cx = ThemeResolver.c(a, Button.c9, Button.cd);
        this.o1 = ThemeResolver.e(a, Button.pz, Button.ng);
        this.o9 = ThemeResolver.e(a, Button.p7, Button.no);
        this.ka = ThemeResolver.d(a, Button.kd, Button.j5);
        this.a0 = ThemeResolver.b(a, Button.a3, Button.av);
        this.o0 = ThemeResolver.e(a, Button.py, Button.nf);
        this.pa = ThemeResolver.e(a, Button.p8, Button.np);
        this.o8 = ThemeResolver.e(a, Button.p6, Button.nn);
        this.o7 = ThemeResolver.e(a, Button.p5, Button.nm);
        this.o5 = ThemeResolver.e(a, Button.p3, Button.nk);
        this.o6 = ThemeResolver.e(a, Button.p4, Button.nl);
    };
    Object.defineProperty(Button.prototype, "r", {
        get: function () {
            return this.q;
        },
        set: function (a) {
            var b = this.q;
            this.q = a;
            if (b != this.q) {
                this.jo("DisplayType", enumGetBox(ButtonDisplayStyle_$type, b), enumGetBox(ButtonDisplayStyle_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "h", {
        get: function () {
            return this.f;
        },
        set: function (a) {
            var b = this.f;
            this.f = a;
            if (b != this.f) {
                this.jo("Density", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "d", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            var b = this.b;
            this.b = a;
            if (b != this.b) {
                this.jo("BaseTheme", enumGetBox(BaseControlTheme_$type, b), enumGetBox(BaseControlTheme_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "g", {
        get: function () {
            return this.e;
        },
        set: function (a) {
            var b = this.e;
            this.e = a;
            if (b != this.e) {
                this.jo("ActualDensity", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "mz", {
        get: function () {
            return this.kr;
        },
        set: function (a) {
            var b = this.kr;
            this.kr = a;
            if (b != this.kr) {
                this.jo("ActualBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "na", {
        get: function () {
            return this.k2;
        },
        set: function (a) {
            var b = this.k2;
            this.k2 = a;
            if (b != this.k2) {
                this.jo("ActualUmbraShadowColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "m7", {
        get: function () {
            return this.kz;
        },
        set: function (a) {
            var b = this.kz;
            this.kz = a;
            if (b != this.kz) {
                this.jo("ActualPenumbraShadowColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "mx", {
        get: function () {
            return this.kp;
        },
        set: function (a) {
            var b = this.kp;
            this.kp = a;
            if (b != this.kp) {
                this.jo("ActualAmbientShadowColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "cb", {
        get: function () {
            return this.bi;
        },
        set: function (a) {
            var b = this.bi;
            this.bi = a;
            if (b != this.bi) {
                this.jo("ActualRestingElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "b9", {
        get: function () {
            return this.bg;
        },
        set: function (a) {
            var b = this.bg;
            this.bg = a;
            if (b != this.bg) {
                this.jo("ActualFocusElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ca", {
        get: function () {
            return this.bh;
        },
        set: function (a) {
            var b = this.bh;
            this.bh = a;
            if (b != this.bh) {
                this.jo("ActualHoverElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "m8", {
        get: function () {
            return this.k0;
        },
        set: function (a) {
            var b = this.k0;
            this.k0 = a;
            if (b != this.k0) {
                this.jo("ActualRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "j2", {
        get: function () {
            return this.jv;
        },
        set: function (a) {
            var b = this.jv;
            this.jv = a;
            if (b != this.jv) {
                this.jo("ActualCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "my", {
        get: function () {
            return this.kq;
        },
        set: function (a) {
            var b = this.kq;
            this.kq = a;
            if (b != this.kq) {
                this.jo("ActualBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "m0", {
        get: function () {
            return this.ks;
        },
        set: function (a) {
            var b = this.ks;
            this.ks = a;
            if (b != this.ks) {
                this.jo("ActualDisabledBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "m1", {
        get: function () {
            return this.kt;
        },
        set: function (a) {
            var b = this.kt;
            this.kt = a;
            if (b != this.kt) {
                this.jo("ActualDisabledBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "m2", {
        get: function () {
            return this.ku;
        },
        set: function (a) {
            var b = this.ku;
            this.ku = a;
            if (b != this.ku) {
                this.jo("ActualDisabledTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "b8", {
        get: function () {
            return this.bf;
        },
        set: function (a) {
            var b = this.bf;
            this.bf = a;
            if (b != this.bf) {
                this.jo("ActualDisabledElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "k", {
        get: function () {
            return this.i;
        },
        set: function (a) {
            var b = this.i;
            this.i = a;
            if (b != this.i) {
                this.jo("ActualElevationMode", enumGetBox(ElevationMode_$type, b), enumGetBox(ElevationMode_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "m9", {
        get: function () {
            return this.k1;
        },
        set: function (a) {
            var b = this.k1;
            this.k1 = a;
            if (b != this.k1) {
                this.jo("ActualTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "m6", {
        get: function () {
            return this.ky;
        },
        set: function (a) {
            var b = this.ky;
            this.ky = a;
            if (b != this.ky) {
                this.jo("ActualHoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "m3", {
        get: function () {
            return this.kv;
        },
        set: function (a) {
            var b = this.kv;
            this.kv = a;
            if (b != this.kv) {
                this.jo("ActualFocusBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "m4", {
        get: function () {
            return this.kw;
        },
        set: function (a) {
            var b = this.kw;
            this.kw = a;
            if (b != this.kw) {
                this.jo("ActualFocusTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "m5", {
        get: function () {
            return this.kx;
        },
        set: function (a) {
            var b = this.kx;
            this.kx = a;
            if (b != this.kx) {
                this.jo("ActualHoverBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "at", {
        get: function () {
            return this.am;
        },
        set: function (a) {
            var b = this.am;
            this.am = a;
            if (b != this.am) {
                this.jo("ActualBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "tm", {
        get: function () {
            return this.mk;
        },
        set: function (a) {
            var b = this.mk;
            this.mk = a;
            if (b != this.mk) {
                this.jo("RaisedBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "to", {
        get: function () {
            return this.mm;
        },
        set: function (a) {
            var b = this.mm;
            this.mm = a;
            if (b != this.mm) {
                this.jo("RaisedDisabledBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "tp", {
        get: function () {
            return this.mn;
        },
        set: function (a) {
            var b = this.mn;
            this.mn = a;
            if (b != this.mn) {
                this.jo("RaisedDisabledBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "tq", {
        get: function () {
            return this.mo;
        },
        set: function (a) {
            var b = this.mo;
            this.mo = a;
            if (b != this.mo) {
                this.jo("RaisedDisabledTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ek", {
        get: function () {
            return this.b2;
        },
        set: function (a) {
            var b = this.b2;
            this.b2 = a;
            if (b != this.b2) {
                this.jo("RaisedDisabledElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "tt", {
        get: function () {
            return this.mr;
        },
        set: function (a) {
            var b = this.mr;
            this.mr = a;
            if (b != this.mr) {
                this.jo("RaisedHoverBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "tn", {
        get: function () {
            return this.ml;
        },
        set: function (a) {
            var b = this.ml;
            this.ml = a;
            if (b != this.ml) {
                this.jo("RaisedBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "en", {
        get: function () {
            return this.b5;
        },
        set: function (a) {
            var b = this.b5;
            this.b5 = a;
            if (b != this.b5) {
                this.jo("RaisedRestingElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "em", {
        get: function () {
            return this.b4;
        },
        set: function (a) {
            var b = this.b4;
            this.b4 = a;
            if (b != this.b4) {
                this.jo("RaisedHoverElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "el", {
        get: function () {
            return this.b3;
        },
        set: function (a) {
            var b = this.b3;
            this.b3 = a;
            if (b != this.b3) {
                this.jo("RaisedFocusElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "be", {
        get: function () {
            return this.as;
        },
        set: function (a) {
            var b = this.as;
            this.as = a;
            if (b != this.as) {
                this.jo("RaisedBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ko", {
        get: function () {
            return this.j1;
        },
        set: function (a) {
            var b = this.j1;
            this.j1 = a;
            {
                this.jo("RaisedCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "tv", {
        get: function () {
            return this.mt;
        },
        set: function (a) {
            var b = this.mt;
            this.mt = a;
            if (b != this.mt) {
                this.jo("RaisedRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sl", {
        get: function () {
            return this.li;
        },
        set: function (a) {
            var b = this.li;
            this.li = a;
            if (b != this.li) {
                this.jo("FlatBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sn", {
        get: function () {
            return this.lk;
        },
        set: function (a) {
            var b = this.lk;
            this.lk = a;
            if (b != this.lk) {
                this.jo("FlatDisabledBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "so", {
        get: function () {
            return this.ll;
        },
        set: function (a) {
            var b = this.ll;
            this.ll = a;
            if (b != this.ll) {
                this.jo("FlatDisabledBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sp", {
        get: function () {
            return this.lm;
        },
        set: function (a) {
            var b = this.lm;
            this.lm = a;
            if (b != this.lm) {
                this.jo("FlatDisabledTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "d6", {
        get: function () {
            return this.bo;
        },
        set: function (a) {
            var b = this.bo;
            this.bo = a;
            if (b != this.bo) {
                this.jo("FlatDisabledElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ss", {
        get: function () {
            return this.lp;
        },
        set: function (a) {
            var b = this.lp;
            this.lp = a;
            if (b != this.lp) {
                this.jo("FlatHoverBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sm", {
        get: function () {
            return this.lj;
        },
        set: function (a) {
            var b = this.lj;
            this.lj = a;
            if (b != this.lj) {
                this.jo("FlatBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "d9", {
        get: function () {
            return this.br;
        },
        set: function (a) {
            var b = this.br;
            this.br = a;
            if (b != this.br) {
                this.jo("FlatRestingElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "d8", {
        get: function () {
            return this.bq;
        },
        set: function (a) {
            var b = this.bq;
            this.bq = a;
            if (b != this.bq) {
                this.jo("FlatHoverElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "d7", {
        get: function () {
            return this.bp;
        },
        set: function (a) {
            var b = this.bp;
            this.bp = a;
            if (b != this.bp) {
                this.jo("FlatFocusElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "su", {
        get: function () {
            return this.lr;
        },
        set: function (a) {
            var b = this.lr;
            this.lr = a;
            if (b != this.lr) {
                this.jo("FlatRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sv", {
        get: function () {
            return this.ls;
        },
        set: function (a) {
            var b = this.ls;
            this.ls = a;
            if (b != this.ls) {
                this.jo("FlatTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "st", {
        get: function () {
            return this.lq;
        },
        set: function (a) {
            var b = this.lq;
            this.lq = a;
            if (b != this.lq) {
                this.jo("FlatHoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sq", {
        get: function () {
            return this.ln;
        },
        set: function (a) {
            var b = this.ln;
            this.ln = a;
            if (b != this.ln) {
                this.jo("FlatFocusBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sr", {
        get: function () {
            return this.lo;
        },
        set: function (a) {
            var b = this.lo;
            this.lo = a;
            if (b != this.lo) {
                this.jo("FlatFocusTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "bb", {
        get: function () {
            return this.ap;
        },
        set: function (a) {
            var b = this.ap;
            this.ap = a;
            if (b != this.ap) {
                this.jo("FlatBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "kl", {
        get: function () {
            return this.jy;
        },
        set: function (a) {
            var b = this.jy;
            this.jy = a;
            {
                this.jo("FlatCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "nb", {
        get: function () {
            return this.k3;
        },
        set: function (a) {
            var b = this.k3;
            this.k3 = a;
            if (b != this.k3) {
                this.jo("BackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "r7", {
        get: function () {
            return this.k5;
        },
        set: function (a) {
            var b = this.k5;
            this.k5 = a;
            if (b != this.k5) {
                this.jo("DisabledBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "r8", {
        get: function () {
            return this.k6;
        },
        set: function (a) {
            var b = this.k6;
            this.k6 = a;
            if (b != this.k6) {
                this.jo("DisabledBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "r9", {
        get: function () {
            return this.k7;
        },
        set: function (a) {
            var b = this.k7;
            this.k7 = a;
            if (b != this.k7) {
                this.jo("DisabledTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "d1", {
        get: function () {
            return this.bj;
        },
        set: function (a) {
            var b = this.bj;
            this.bj = a;
            if (b != this.bj) {
                this.jo("DisabledElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "o", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            var b = this.j;
            this.j = a;
            if (b != this.j) {
                this.jo("ElevationMode", enumGetBox(ElevationMode_$type, b), enumGetBox(ElevationMode_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sy", {
        get: function () {
            return this.lv;
        },
        set: function (a) {
            var b = this.lv;
            this.lv = a;
            if (b != this.lv) {
                this.jo("HoverBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "nc", {
        get: function () {
            return this.k4;
        },
        set: function (a) {
            var b = this.k4;
            this.k4 = a;
            if (b != this.k4) {
                this.jo("BorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "eo", {
        get: function () {
            return this.b6;
        },
        set: function (a) {
            var b = this.b6;
            this.b6 = a;
            if (b != this.b6) {
                this.jo("RestingElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "eb", {
        get: function () {
            return this.bt;
        },
        set: function (a) {
            var b = this.bt;
            this.bt = a;
            if (b != this.bt) {
                this.jo("HoverElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ea", {
        get: function () {
            return this.bs;
        },
        set: function (a) {
            var b = this.bs;
            this.bs = a;
            if (b != this.bs) {
                this.jo("FocusElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "u", {
        get: function () {
            return this.t;
        },
        set: function (a) {
            var b = this.t;
            this.t = a;
            if (b != this.t) {
                this.jo("TextStyle", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ty", {
        get: function () {
            return this.mw;
        },
        set: function (a) {
            var b = this.mw;
            this.mw = a;
            if (b != this.mw) {
                this.jo("TextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sz", {
        get: function () {
            return this.lx;
        },
        set: function (a) {
            var b = this.lx;
            this.lx = a;
            if (b != this.lx) {
                this.jo("HoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "tx", {
        get: function () {
            return this.mv;
        },
        set: function (a) {
            var b = this.mv;
            this.mv = a;
            if (b != this.mv) {
                this.jo("RippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "tw", {
        get: function () {
            return this.mu;
        },
        set: function (a) {
            var b = this.mu;
            this.mu = a;
            if (b != this.mu) {
                this.jo("RaisedTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "tu", {
        get: function () {
            return this.ms;
        },
        set: function (a) {
            var b = this.ms;
            this.ms = a;
            if (b != this.ms) {
                this.jo("RaisedHoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "tr", {
        get: function () {
            return this.mp;
        },
        set: function (a) {
            var b = this.mp;
            this.mp = a;
            if (b != this.mp) {
                this.jo("RaisedFocusBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ts", {
        get: function () {
            return this.mq;
        },
        set: function (a) {
            var b = this.mq;
            this.mq = a;
            if (b != this.mq) {
                this.jo("RaisedFocusTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sw", {
        get: function () {
            return this.lt;
        },
        set: function (a) {
            var b = this.lt;
            this.lt = a;
            if (b != this.lt) {
                this.jo("FocusBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sx", {
        get: function () {
            return this.lu;
        },
        set: function (a) {
            var b = this.lu;
            this.lu = a;
            if (b != this.lu) {
                this.jo("FocusTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "au", {
        get: function () {
            return this.an;
        },
        set: function (a) {
            var b = this.an;
            this.an = a;
            if (b != this.an) {
                this.jo("BorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "j4", {
        get: function () {
            return this.jw;
        },
        set: function (a) {
            var b = this.jw;
            this.jw = a;
            {
                this.jo("CornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "tb", {
        get: function () {
            return this.l9;
        },
        set: function (a) {
            var b = this.l9;
            this.l9 = a;
            if (b != this.l9) {
                this.jo("OutlinedBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "td", {
        get: function () {
            return this.mb;
        },
        set: function (a) {
            var b = this.mb;
            this.mb = a;
            if (b != this.mb) {
                this.jo("OutlinedDisabledBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "te", {
        get: function () {
            return this.mc;
        },
        set: function (a) {
            var b = this.mc;
            this.mc = a;
            if (b != this.mc) {
                this.jo("OutlinedDisabledBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "tf", {
        get: function () {
            return this.md;
        },
        set: function (a) {
            var b = this.md;
            this.md = a;
            if (b != this.md) {
                this.jo("OutlinedDisabledTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "eg", {
        get: function () {
            return this.by;
        },
        set: function (a) {
            var b = this.by;
            this.by = a;
            if (b != this.by) {
                this.jo("OutlinedDisabledElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ti", {
        get: function () {
            return this.mg;
        },
        set: function (a) {
            var b = this.mg;
            this.mg = a;
            if (b != this.mg) {
                this.jo("OutlinedHoverBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "tc", {
        get: function () {
            return this.ma;
        },
        set: function (a) {
            var b = this.ma;
            this.ma = a;
            if (b != this.ma) {
                this.jo("OutlinedBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ej", {
        get: function () {
            return this.b1;
        },
        set: function (a) {
            var b = this.b1;
            this.b1 = a;
            if (b != this.b1) {
                this.jo("OutlinedRestingElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ei", {
        get: function () {
            return this.b0;
        },
        set: function (a) {
            var b = this.b0;
            this.b0 = a;
            if (b != this.b0) {
                this.jo("OutlinedHoverElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "eh", {
        get: function () {
            return this.bz;
        },
        set: function (a) {
            var b = this.bz;
            this.bz = a;
            if (b != this.bz) {
                this.jo("OutlinedFocusElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "bd", {
        get: function () {
            return this.ar;
        },
        set: function (a) {
            var b = this.ar;
            this.ar = a;
            if (b != this.ar) {
                this.jo("OutlinedBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "kn", {
        get: function () {
            return this.j0;
        },
        set: function (a) {
            var b = this.j0;
            this.j0 = a;
            {
                this.jo("OutlinedCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "tk", {
        get: function () {
            return this.mi;
        },
        set: function (a) {
            var b = this.mi;
            this.mi = a;
            if (b != this.mi) {
                this.jo("OutlinedRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "tl", {
        get: function () {
            return this.mj;
        },
        set: function (a) {
            var b = this.mj;
            this.mj = a;
            if (b != this.mj) {
                this.jo("OutlinedTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "tj", {
        get: function () {
            return this.mh;
        },
        set: function (a) {
            var b = this.mh;
            this.mh = a;
            if (b != this.mh) {
                this.jo("OutlinedHoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "tg", {
        get: function () {
            return this.me;
        },
        set: function (a) {
            var b = this.me;
            this.me = a;
            if (b != this.me) {
                this.jo("OutlinedFocusBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "th", {
        get: function () {
            return this.mf;
        },
        set: function (a) {
            var b = this.mf;
            this.mf = a;
            if (b != this.mf) {
                this.jo("OutlinedFocusTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sa", {
        get: function () {
            return this.k8;
        },
        set: function (a) {
            var b = this.k8;
            this.k8 = a;
            if (b != this.k8) {
                this.jo("FabBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sc", {
        get: function () {
            return this.la;
        },
        set: function (a) {
            var b = this.la;
            this.la = a;
            if (b != this.la) {
                this.jo("FabDisabledBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sd", {
        get: function () {
            return this.lb;
        },
        set: function (a) {
            var b = this.lb;
            this.lb = a;
            if (b != this.lb) {
                this.jo("FabDisabledBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "se", {
        get: function () {
            return this.lc;
        },
        set: function (a) {
            var b = this.lc;
            this.lc = a;
            if (b != this.lc) {
                this.jo("FabDisabledTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "d2", {
        get: function () {
            return this.bk;
        },
        set: function (a) {
            var b = this.bk;
            this.bk = a;
            if (b != this.bk) {
                this.jo("FabDisabledElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sh", {
        get: function () {
            return this.lw;
        },
        set: function (a) {
            var b = this.lw;
            this.lw = a;
            if (b != this.lw) {
                this.jo("FabHoverBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sb", {
        get: function () {
            return this.k9;
        },
        set: function (a) {
            var b = this.k9;
            this.k9 = a;
            if (b != this.k9) {
                this.jo("FabBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "d5", {
        get: function () {
            return this.bn;
        },
        set: function (a) {
            var b = this.bn;
            this.bn = a;
            if (b != this.bn) {
                this.jo("FabRestingElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "d4", {
        get: function () {
            return this.bm;
        },
        set: function (a) {
            var b = this.bm;
            this.bm = a;
            if (b != this.bm) {
                this.jo("FabHoverElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "d3", {
        get: function () {
            return this.bl;
        },
        set: function (a) {
            var b = this.bl;
            this.bl = a;
            if (b != this.bl) {
                this.jo("FabFocusElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ba", {
        get: function () {
            return this.ao;
        },
        set: function (a) {
            var b = this.ao;
            this.ao = a;
            if (b != this.ao) {
                this.jo("FabBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "kk", {
        get: function () {
            return this.jx;
        },
        set: function (a) {
            var b = this.jx;
            this.jx = a;
            {
                this.jo("FabCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sj", {
        get: function () {
            return this.lg;
        },
        set: function (a) {
            var b = this.lg;
            this.lg = a;
            if (b != this.lg) {
                this.jo("FabRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sk", {
        get: function () {
            return this.lh;
        },
        set: function (a) {
            var b = this.lh;
            this.lh = a;
            if (b != this.lh) {
                this.jo("FabTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "si", {
        get: function () {
            return this.lf;
        },
        set: function (a) {
            var b = this.lf;
            this.lf = a;
            if (b != this.lf) {
                this.jo("FabHoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sf", {
        get: function () {
            return this.ld;
        },
        set: function (a) {
            var b = this.ld;
            this.ld = a;
            if (b != this.ld) {
                this.jo("FabFocusBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "sg", {
        get: function () {
            return this.le;
        },
        set: function (a) {
            var b = this.le;
            this.le = a;
            if (b != this.le) {
                this.jo("FabFocusTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "s0", {
        get: function () {
            return this.ly;
        },
        set: function (a) {
            var b = this.ly;
            this.ly = a;
            if (b != this.ly) {
                this.jo("IconBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "s2", {
        get: function () {
            return this.l0;
        },
        set: function (a) {
            var b = this.l0;
            this.l0 = a;
            if (b != this.l0) {
                this.jo("IconDisabledBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "s3", {
        get: function () {
            return this.l1;
        },
        set: function (a) {
            var b = this.l1;
            this.l1 = a;
            if (b != this.l1) {
                this.jo("IconDisabledBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "s4", {
        get: function () {
            return this.l2;
        },
        set: function (a) {
            var b = this.l2;
            this.l2 = a;
            if (b != this.l2) {
                this.jo("IconDisabledTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ec", {
        get: function () {
            return this.bu;
        },
        set: function (a) {
            var b = this.bu;
            this.bu = a;
            if (b != this.bu) {
                this.jo("IconDisabledElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "s7", {
        get: function () {
            return this.l5;
        },
        set: function (a) {
            var b = this.l5;
            this.l5 = a;
            if (b != this.l5) {
                this.jo("IconHoverBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "s1", {
        get: function () {
            return this.lz;
        },
        set: function (a) {
            var b = this.lz;
            this.lz = a;
            if (b != this.lz) {
                this.jo("IconBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ef", {
        get: function () {
            return this.bx;
        },
        set: function (a) {
            var b = this.bx;
            this.bx = a;
            if (b != this.bx) {
                this.jo("IconRestingElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ee", {
        get: function () {
            return this.bw;
        },
        set: function (a) {
            var b = this.bw;
            this.bw = a;
            if (b != this.bw) {
                this.jo("IconHoverElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ed", {
        get: function () {
            return this.bv;
        },
        set: function (a) {
            var b = this.bv;
            this.bv = a;
            if (b != this.bv) {
                this.jo("IconFocusElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "bc", {
        get: function () {
            return this.aq;
        },
        set: function (a) {
            var b = this.aq;
            this.aq = a;
            if (b != this.aq) {
                this.jo("IconBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "km", {
        get: function () {
            return this.jz;
        },
        set: function (a) {
            var b = this.jz;
            this.jz = a;
            {
                this.jo("IconCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "s9", {
        get: function () {
            return this.l7;
        },
        set: function (a) {
            var b = this.l7;
            this.l7 = a;
            if (b != this.l7) {
                this.jo("IconRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ta", {
        get: function () {
            return this.l8;
        },
        set: function (a) {
            var b = this.l8;
            this.l8 = a;
            if (b != this.l8) {
                this.jo("IconTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "s8", {
        get: function () {
            return this.l6;
        },
        set: function (a) {
            var b = this.l6;
            this.l6 = a;
            if (b != this.l6) {
                this.jo("IconHoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "s5", {
        get: function () {
            return this.l3;
        },
        set: function (a) {
            var b = this.l3;
            this.l3 = a;
            if (b != this.l3) {
                this.jo("IconFocusBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "s6", {
        get: function () {
            return this.l4;
        },
        set: function (a) {
            var b = this.l4;
            this.l4 = a;
            if (b != this.l4) {
                this.jo("IconFocusTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "h0", {
        get: function () {
            return this.e0;
        },
        set: function (a) {
            var b = this.e0;
            this.e0 = a;
            if (b != this.e0) {
                this.jo("InputId", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "hy", {
        get: function () {
            return this.ez;
        },
        set: function (a) {
            var b = this.ez;
            this.ez = a;
            if (b != this.ez) {
                this.jo("Id", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "f5", {
        get: function () {
            return this.ew;
        },
        set: function (a) {
            var b = this.ew;
            this.ew = a;
            if (b != this.ew) {
                this.jo("Display", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "g7", {
        get: function () {
            return this.ex;
        },
        set: function (a) {
            var b = this.ex;
            this.ex = a;
            if (b != this.ex) {
                this.jo("FlexDirection", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "g9", {
        get: function () {
            return this.ey;
        },
        set: function (a) {
            var b = this.ey;
            this.ey = a;
            if (b != this.ey) {
                this.jo("FlexGrow", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "fp", {
        get: function () {
            return this.eu;
        },
        set: function (a) {
            var b = this.eu;
            this.eu = a;
            if (b != this.eu) {
                this.jo("AlignItems", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "et", {
        get: function () {
            return this.es;
        },
        set: function (a) {
            var b = this.es;
            this.es = a;
            if (b != this.es) {
                this.jo("Value", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "h6", {
        get: function () {
            return this.e1;
        },
        set: function (a) {
            var b = this.e1;
            this.e1 = a;
            if (b != this.e1) {
                this.jo("Name", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ag", {
        get: function () {
            return this.y;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ep", {
        get: function () {
            return this.b7;
        },
        set: function (a) {
            var b = this.b7;
            this.b7 = a;
            this.y = true;
            if (b != this.b7) {
                this.jo("TabIndex", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "focused", {
        get: function () {
            return this.aa;
        },
        set: function (a) {
            var b = this.aa;
            this.aa = a;
            if (b != this.aa) {
                this.jo("IsFocused", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "aj", {
        get: function () {
            return this.ab;
        },
        set: function (a) {
            var b = this.ab;
            this.ab = a;
            if (b != this.ab) {
                this.jo("IsFocusStyleEnabled", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "fr", {
        get: function () {
            return this.ev;
        },
        set: function (a) {
            var b = this.ev;
            this.ev = a;
            if (b != this.ev) {
                this.jo("AriaLabel", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ae", {
        get: function () {
            return this.w;
        },
        set: function (a) {
            var b = this.w;
            this.w = a;
            if (b != this.w) {
                this.jo("DisableRipple", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ad", {
        get: function () {
            return this.v;
        },
        set: function (a) {
            var b = this.v;
            this.v = a;
            if (b != this.v) {
                this.jo("ActualDisableRipple", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "ak", {
        get: function () {
            return this.ac;
        },
        set: function (a) {
            var b = this.ac;
            this.ac = a;
            if (b != this.ac) {
                this.jo("IsHover", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "disabled", {
        get: function () {
            return this.z;
        },
        set: function (a) {
            var b = this.z;
            this.z = a;
            if (b != this.z) {
                this.jo("IsDisabled", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "af", {
        get: function () {
            return this.x;
        },
        set: function (a) {
            var b = this.x;
            this.x = a;
            if (b != this.x) {
                this.jo("DisableTransitions", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Button.prototype.jp = function () {
        this.jg();
        this.view.al(this.m8, BrushUtil.g(0, 0, 0, 0));
        this.js();
    };
    Object.defineProperty(Button.prototype, "a", {
        get: function () {
            var a = new AnimationKeyFrameEffectTiming();
            a.g = 300;
            a.b = 0;
            return a;
        },
        enumerable: true,
        configurable: true
    });
    Button.prototype.jg = function () {
        this.view.x();
    };
    Button.prototype.onDetachedFromUI = function () {
        this.view.ab();
    };
    Button.prototype.onAttachedToUI = function () {
        this.view.z();
    };
    Button.prototype.appendButtonContent = function (a) {
        this.view.w(a);
    };
    Button.prototype.al = function () {
        return this.view.f();
    };
    Button.prototype.provideContainer = function (a) {
        this.view.aa(a);
    };
    Button.$t = markType(Button, 'Button', Base.$, [INotifyPropertyChanged_$type]);
    Button.ri = BrushUtil.g(66, 0, 0, 0);
    Button.q6 = BrushUtil.g(30, 0, 0, 0);
    Button.px = BrushUtil.g(20, 0, 0, 0);
    Button.n = 1;
    Button.q9 = BrushUtil.g(10, 0, 0, 0);
    Button.ra = BrushUtil.g(10, 0, 0, 0);
    Button.rb = BrushUtil.g(66, 0, 0, 0);
    Button.dp = 0;
    Button.ds = 2;
    Button.dr = 4;
    Button.dq = 8;
    Button.q8 = BrushUtil.g(138, 0, 0, 0);
    Button.rg = BrushUtil.g(255, 255, 255, 255);
    Button.kh = new CornerRadius(0, 4);
    Button.a7 = NaN;
    Button.q7 = BrushUtil.g(255, 228, 28, 119);
    Button.rh = BrushUtil.g(255, 0, 0, 0);
    Button.rf = BrushUtil.g(255, 0, 0, 0);
    Button.re = BrushUtil.g(255, 220, 83, 145);
    Button.rc = BrushUtil.g(255, 220, 83, 145);
    Button.rd = BrushUtil.g(255, 0, 0, 0);
    Button.qb = BrushUtil.g(0, 0, 0, 0);
    Button.qc = BrushUtil.g(0, 0, 0, 0);
    Button.qd = BrushUtil.g(66, 0, 0, 0);
    Button.dc = 0;
    Button.df = 0;
    Button.de = 0;
    Button.dd = 0;
    Button.qa = BrushUtil.g(138, 0, 0, 0);
    Button.qi = null;
    Button.ke = new CornerRadius(0, 4);
    Button.a4 = NaN;
    Button.p9 = BrushUtil.g(0, 0, 0, 0);
    Button.qj = BrushUtil.g(255, 228, 28, 119);
    Button.qh = BrushUtil.g(255, 228, 28, 119);
    Button.qg = BrushUtil.g(13, 228, 28, 119);
    Button.qe = BrushUtil.g(30, 228, 28, 119);
    Button.qf = BrushUtil.g(255, 228, 28, 119);
    Button.qx = BrushUtil.g(0, 0, 0, 0);
    Button.qy = BrushUtil.g(30, 0, 0, 0);
    Button.qz = BrushUtil.g(66, 0, 0, 0);
    Button.dk = 0;
    Button.dn = 0;
    Button.dm = 0;
    Button.dl = 0;
    Button.qw = BrushUtil.g(30, 0, 0, 0);
    Button.q4 = BrushUtil.g(0, 0, 0, 0);
    Button.kg = new CornerRadius(0, 4);
    Button.a6 = 1;
    Button.qv = BrushUtil.g(0, 0, 0, 0);
    Button.q5 = BrushUtil.g(255, 228, 28, 119);
    Button.q3 = BrushUtil.g(255, 228, 28, 119);
    Button.q2 = BrushUtil.g(13, 228, 28, 119);
    Button.q0 = BrushUtil.g(30, 228, 28, 119);
    Button.q1 = BrushUtil.g(255, 228, 28, 119);
    Button.qm = BrushUtil.g(0, 0, 0, 0);
    Button.qn = BrushUtil.g(0, 0, 0, 0);
    Button.qo = BrushUtil.g(66, 0, 0, 0);
    Button.dg = 0;
    Button.dj = 0;
    Button.di = 0;
    Button.dh = 0;
    Button.ql = BrushUtil.g(138, 0, 0, 0);
    Button.qt = null;
    Button.kf = new CornerRadius(0, 28);
    Button.a5 = NaN;
    Button.qk = BrushUtil.g(0, 0, 0, 0);
    Button.qu = BrushUtil.g(255, 0, 0, 0);
    Button.qs = BrushUtil.g(255, 0, 0, 0);
    Button.qr = BrushUtil.g(30, 0, 0, 0);
    Button.qp = BrushUtil.g(66, 0, 0, 0);
    Button.qq = BrushUtil.g(255, 0, 0, 0);
    Button.p0 = BrushUtil.g(10, 0, 0, 0);
    Button.p1 = BrushUtil.g(10, 0, 0, 0);
    Button.p2 = BrushUtil.g(66, 0, 0, 0);
    Button.c8 = 0;
    Button.db = 6;
    Button.da = 12;
    Button.c9 = 12;
    Button.pz = BrushUtil.g(138, 0, 0, 0);
    Button.p7 = BrushUtil.g(255, 255, 255, 255);
    Button.kd = new CornerRadius(0, 28);
    Button.a3 = NaN;
    Button.py = BrushUtil.g(255, 228, 28, 119);
    Button.p8 = BrushUtil.g(255, 0, 0, 0);
    Button.p6 = BrushUtil.g(255, 0, 0, 0);
    Button.p5 = BrushUtil.g(255, 220, 83, 145);
    Button.p3 = BrushUtil.g(255, 220, 83, 145);
    Button.p4 = BrushUtil.g(255, 0, 0, 0);
    Button.oz = BrushUtil.g(100, 33, 150, 243);
    Button.on = BrushUtil.g(70, 33, 150, 243);
    Button.ne = BrushUtil.g(40, 33, 150, 243);
    Button.l = 2;
    Button.oq = BrushUtil.g(10, 0, 0, 0);
    Button.or = BrushUtil.g(10, 0, 0, 0);
    Button.os = BrushUtil.g(66, 0, 0, 0);
    Button.cs = 0;
    Button.cv = 0;
    Button.cu = 0;
    Button.ct = 2;
    Button.op = BrushUtil.g(138, 0, 0, 0);
    Button.ox = BrushUtil.g(255, 255, 255, 255);
    Button.j9 = new CornerRadius(0, 3);
    Button.az = NaN;
    Button.oo = BrushUtil.g(255, 33, 150, 243);
    Button.oy = BrushUtil.g(255, 255, 255, 255);
    Button.ow = BrushUtil.g(255, 255, 255, 255);
    Button.ov = BrushUtil.g(255, 27, 135, 220);
    Button.ot = BrushUtil.g(255, 21, 112, 184);
    Button.ou = BrushUtil.g(255, 255, 255, 255);
    Button.ns = BrushUtil.g(0, 0, 0, 0);
    Button.nt = BrushUtil.g(0, 0, 0, 0);
    Button.nu = BrushUtil.g(66, 0, 0, 0);
    Button.cg = 0;
    Button.cj = 0;
    Button.ci = 0;
    Button.ch = 2;
    Button.nr = BrushUtil.g(138, 0, 0, 0);
    Button.nz = BrushUtil.g(100, 33, 150, 243);
    Button.j6 = new CornerRadius(0, 3);
    Button.aw = NaN;
    Button.nq = BrushUtil.g(0, 0, 0, 0);
    Button.n0 = BrushUtil.g(255, 119, 119, 119);
    Button.ny = BrushUtil.g(255, 119, 119, 119);
    Button.nx = BrushUtil.g(26, 33, 150, 243);
    Button.nv = BrushUtil.g(0, 0, 0, 0);
    Button.nw = BrushUtil.g(255, 33, 150, 243);
    Button.oe = BrushUtil.g(0, 0, 0, 0);
    Button.of = BrushUtil.g(30, 0, 0, 0);
    Button.og = BrushUtil.g(66, 0, 0, 0);
    Button.co = 0;
    Button.cr = 0;
    Button.cq = 0;
    Button.cp = 2;
    Button.od = BrushUtil.g(255, 33, 150, 243);
    Button.ol = BrushUtil.g(0, 0, 0, 0);
    Button.j8 = new CornerRadius(0, 3);
    Button.ay = 1;
    Button.oc = BrushUtil.g(0, 0, 0, 0);
    Button.om = BrushUtil.g(255, 33, 150, 243);
    Button.ok = BrushUtil.g(255, 33, 150, 243);
    Button.oj = BrushUtil.g(26, 33, 150, 243);
    Button.oh = BrushUtil.g(255, 33, 150, 243);
    Button.oi = BrushUtil.g(255, 255, 255, 255);
    Button.n3 = BrushUtil.g(0, 0, 0, 0);
    Button.n4 = BrushUtil.g(0, 0, 0, 0);
    Button.n5 = BrushUtil.g(66, 0, 0, 0);
    Button.ck = 0;
    Button.cn = 0;
    Button.cm = 0;
    Button.cl = 2;
    Button.n2 = BrushUtil.g(138, 0, 0, 0);
    Button.oa = null;
    Button.j7 = new CornerRadius(0, 28);
    Button.ax = NaN;
    Button.n1 = BrushUtil.g(0, 0, 0, 0);
    Button.ob = BrushUtil.g(255, 119, 119, 119);
    Button.n9 = BrushUtil.g(255, 119, 119, 119);
    Button.n8 = BrushUtil.g(30, 0, 0, 0);
    Button.n6 = BrushUtil.g(66, 0, 0, 0);
    Button.n7 = BrushUtil.g(255, 33, 150, 243);
    Button.nh = BrushUtil.g(10, 0, 0, 0);
    Button.ni = BrushUtil.g(10, 0, 0, 0);
    Button.nj = BrushUtil.g(66, 0, 0, 0);
    Button.cc = 0;
    Button.cf = 0;
    Button.ce = 0;
    Button.cd = 2;
    Button.ng = BrushUtil.g(138, 0, 0, 0);
    Button.no = BrushUtil.g(255, 255, 255, 255);
    Button.j5 = new CornerRadius(0, 28);
    Button.av = NaN;
    Button.nf = BrushUtil.g(255, 33, 150, 243);
    Button.np = BrushUtil.g(255, 255, 255, 255);
    Button.nn = BrushUtil.g(255, 255, 255, 255);
    Button.nm = BrushUtil.g(255, 27, 135, 220);
    Button.nk = BrushUtil.g(255, 21, 112, 184);
    Button.nl = BrushUtil.g(255, 255, 255, 255);
    Button.c = 2;
    Button.er = 0;
    Button.eq = 0;
    return Button;
}(Base));
export { Button };
//# sourceMappingURL=ButtonView_combined.js.map
